import React, { useEffect, useState } from "react";
import SideBar from "../Components/SideBar";
import callAdminUsersApi from "../callApi/adminUsers";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";
import ReactPaginate from "react-paginate";


const ITEMS_PER_PAGE = 10;
export default function AdminUsers() {
  const navigate = useNavigate();
  const [usersData, setUsersData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [revealedPasswords, setRevealedPasswords] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(true));
    callAdminUsersApi().then((res) => {
      dispatch(setLoading(false));
      setUsersData(res);
    });
  }, []);

  const handlePageClick = (data) => {
    const selectedPage = data.selected;
    setCurrentPage(selectedPage);
  };

  const togglePasswordVisibility = (id) => {
    if (revealedPasswords.includes(id)) {
      // If the clicked password is already revealed, close it
      setRevealedPasswords([]);
    } else {
      // Otherwise, toggle the clicked password
      setRevealedPasswords([id]);
    }
  };

  const paginatedData = usersData.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE
  );

  return (
    <div className="admin-shop-comments">
      <SideBar />
      <div className="admin-container">
          <h1>Admin Users</h1>
          <br />
          <br />
          <Link to="/admin/users/create" className="add-user_" style={{color: 'white', backgroundColor: '#245369', padding:'10px', textDecoration:'none'}}>
            + Add User
          </Link>
          <br />
          <br />
          <table className="admin-shop-comments-table">
            <thead>
            <tr>
                <th>First name</th>
                <th>Last name</th>
                <th>Username</th>
                <th>Password</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
             
              {Array.isArray(paginatedData) && paginatedData.length > 0 ? (
                paginatedData.map((item) => (
                  <tr
                    style={{ cursor: "pointer" }}
                    key={item.AdminId}
                    onClick={() => navigate("/admin/users/edit/" + item.AdminId)}
                  >
                    <td>{item.FirstName}</td>
                    <td>{item.LastName}</td>
                    <td>{item.UserName}</td>
                    <td onClick={(e) => e.stopPropagation()}>
                      {revealedPasswords.includes(item.AdminId) ? (
                        item.password
                      ) : (
                        <span
                          onClick={() => togglePasswordVisibility(item.AdminId)}
                          onBlur={() => setRevealedPasswords([])}
                          tabIndex={0}
                        >
                          ********
                        </span>
                      )}
                    </td>
                    <td>{item.Role}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No Record Found</td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="newsletterPagination">
        <ReactPaginate
          pageCount={Math.ceil(usersData.length / ITEMS_PER_PAGE)}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          subContainerClassName="pages pagination"
          activeClassName="active"
        />
        </div>
        </div>
      </div>
  );
}
